// TangentIcons — community-maintained Hedera token logos on GitHub CDN
const tangent = (tokenId: string) =>
  `https://raw.githubusercontent.com/shades2/TangentIcons/main/Tokens/${tokenId}/logo.png`;

// CoinGecko CDN — for tokens not in TangentIcons
const coingecko = (id: number, filename: string) =>
  `https://coin-images.coingecko.com/coins/images/${id}/small/${filename}`;

const TOKEN_LOGOS: Record<string, string> = {
  // Native
  HBAR: coingecko(3688, 'hbar.png?1696504364'),

  // Stablecoins
  '0.0.456858': tangent('0.0.456858'),  // USDC
  '0.0.456859': coingecko(325, 'Tether.png?1696501661'), // USDT

  // DeFi / Ecosystem (TangentIcons)
  '0.0.786931': tangent('0.0.786931'),  // GRELF
  '0.0.834116': tangent('0.0.834116'),  // HBARX
  '0.0.632593': tangent('0.0.632593'),
  '0.0.751086': tangent('0.0.751086'),
  '0.0.752985': tangent('0.0.752985'),
  '0.0.784681': tangent('0.0.784681'),
  '0.0.795239': tangent('0.0.795239'),
  '0.0.824700': tangent('0.0.824700'),
  '0.0.824815': tangent('0.0.824815'),
  '0.0.859814': tangent('0.0.859814'),
  '0.0.986963': tangent('0.0.986963'),
  '0.0.127877': tangent('0.0.127877'),
  '0.0.148698': tangent('0.0.148698'),
  '0.0.209368': tangent('0.0.209368'),
  '0.0.485527': tangent('0.0.485527'),
  '0.0.624505': tangent('0.0.624505'),

  // DeFi (CoinGecko)
  '0.0.731861': coingecko(27401, 'SAUCE_ICON_FINAL_200x200.png?1748588084'), // SAUCE

  // Testnet — for testing logo rendering
  '0.0.7893908': tangent('0.0.456858'), // Test token → uses USDC logo
};

export const getTokenLogoUrl = (tokenId: string): string | null =>
  TOKEN_LOGOS[tokenId] ?? null;
